import appendSlide from './methods/appendSlide.js';
import prependSlide from './methods/prependSlide.js';
import addSlide from './methods/addSlide.js';
import removeSlide from './methods/removeSlide.js';
import removeAllSlides from './methods/removeAllSlides.js';
export default function Manipulation({
  swiper
}) {
  Object.assign(swiper, {
    appendSlide: appendSlide.bind(swiper),
    prependSlide: prependSlide.bind(swiper),
    addSlide: addSlide.bind(swiper),
    removeSlide: removeSlide.bind(swiper),
    removeAllSlides: removeAllSlides.bind(swiper)
  });
}


//////////////////
// WEBPACK FOOTER
// /Users/nicola/Sites/plasticseurope.multisite/public_html/wp-content/themes/plasticseurope-theme/node_modules/swiper/modules/manipulation/manipulation.js
// module id = 98
// module chunks = 0 1